import React, { useEffect, useContext, useState, useRef } from 'react';
// import './Home.scss';
import "./style.css"
import ElasticEmailForm from "../components/ElasticEmailForm";
import { UserContext } from "../contexts/user";
import Purchase from '../components/Stripe/Purchase';
import {
  HeroSection, ModulesSection, FacultySection, CourseFeaturesSection,
  ValuePropositionSection, TestimonialsSection, ContentOwnershipSection,
  PricingSection, FAQSection, FooterCTASection
} from "../components/HomeElements"


const Home = () => {
  const [templaterCourse, setTemplatedCourse] = useState();
  const [courseService, setCourseService] = useState();
  const [checkoutData, setCheckoutData] = useState(null);
  const [customerCards, setCustomerCards] = useState([]);
  const [showPurchase, setShowPurchase] = useState(false); // ADD THIS LINE
  const purchaseRef = useRef();
  const rand = useRef();
  const { user } = useContext(UserContext);

  useEffect(() => {
    (async function () {
      await Promise.all([getCourseService(), getTemplatedCourse()])
    })();
    rand.current = Math.floor(Math.random() * 100) + 1;
  }, []);


  const getCourseService = async () => {
    if (courseService) return;
    // const firebase = (await import("@/firebase")).default;

    // if (!firebase.auth().currentUser) return;

    // const token = await firebase.auth().currentUser.getIdToken();
    const mongoUrl = new URL(`https://bridge.hackernoon.com/p/hackernoonMongo2/services`);
    // const mongoUrl = new URL(`http://localhost:8086/services`);
    mongoUrl.searchParams.append("id", "68b959f9eeb27a895ba20f48");

    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
      });
      const response = await req.json();

      // console.log("Service Response", response);
      if (response.ok === true) {
        const s = response?.serviceData;
        const options = s?.priceOptions.map(p => {
          return { ...p, price: parseFloat(p.price["$numberDecimal"]) };
        });
        // console.log("heree", s)
        setCourseService({ ...s, priceOptions: options });
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  }

  const getTemplatedCourse = async () => {
    const mongoUrl = new URL(`https://bridge.hackernoon.com/p/courses`);
    // const mongoUrl = new URL(`http://localhost:8087`);
    if (templaterCourse) return;

    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`,
        },
      });
      const response = await req.json();

      // console.log("Service Response", response);
      if (response?.ok === true) {
        // console.log("heree", response)
        setTemplatedCourse(response?.course);
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  }

  const handleClickOutside = e => {
    const elmId = e?.target?.id;
    if (!purchaseRef?.current?.contains(e.target) && elmId !== "buy-btn") {
      if (checkoutData) {
        window.gtag?.("event", "stripe_checkout_closed", {
          dismiss_reason: "user_dismissed_checkout"
        });
        
        setCheckoutData(null);
        
      }
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  });

  const handleSetCheckoutData = async () => {
    if (checkoutData) {
      return setCheckoutData(null);
    }

    if (!courseService) return;

    const headers = {
      "Content-Type": "application/json"
    }

    const firebase = (await import("firebase/app")).default;

    if (firebase.auth().currentUser) {
      const token = await firebase.auth().currentUser.getIdToken();
      const bearer = `Bearer ${token}`;
      headers["Authorization"] = bearer;
    }
    const url = new URL("https://bridge.hackernoon.com/p/hackernoonMongo2/services/single-checkout");
    // const url = new URL("http://localhost:8087/services/single-checkout");
    url.searchParams.append("optionId", courseService?.priceOptions[0]?._id);
    url.searchParams.append("serviceId", courseService?._id);
    url.searchParams.append("recurrence", "none");

    const params = {};

    try {
      const req = await fetch(url?.toString(), {
        method: "GET",
        headers
      });
      const response = await req.json();
      // console.log("yoo heree", response)
      if (response.ok === true) {
        const data = {
          ...response?.checkoutData,
          params: { ...response?.checkoutData?.params, ...params },
        };

        setCheckoutData(data);
        if (response?.customerCards && response?.customerCards?.length > 0) {
          setCustomerCards(response?.customerCards);
        }
        // close();
      }
    } catch (e) {
      console.log("something went wrong!", e);
    }
  };

  const applyCoupon = async (discount_code, params, paymentIntentId) => {
    const mongoUrl = new URL(
      "https://us-central1-hackernoon-app.cloudfunctions.net/hackernoonMongo2/services/validate-single-service-coupon",
    );
    // const mongoUrl = new URL("http://localhost:8087/services/validate-single-service-coupon");
    try {
      const req = await fetch(mongoUrl?.toString(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: bearer,
        },
        body: JSON.stringify({discountCode: discount_code, ...params, paymentIntentId}),
        // mode: "cors",
        // credentials: "include",
      });
      const response = await req.json();
      // console.log("response", response);
      if (response.ok) {
        setCheckoutData(prev => ({ ...prev, ...response?.checkoutData}));
        return true;
      }else {
        return false;
      }
    } catch (e) {
      console.log("something went wrong!", e);
      return false;
    }
  }


  return (
    <>
      <HeroSection />
      <ModulesSection templaterCourse={templaterCourse} />
      <FacultySection />
      <CourseFeaturesSection />
      <ValuePropositionSection />
      <TestimonialsSection />
      <ContentOwnershipSection />
      <PricingSection
        courseService={courseService}
        handleSetCheckoutData={handleSetCheckoutData}
        rand={rand.current}
      />
      <FAQSection />
      <FooterCTASection />
      <div ref={purchaseRef}>
        <Purchase
          showPurchase={checkoutData !== null}
          close={() => setCheckoutData(null)}
          checkoutData={checkoutData}
          customerCards={customerCards}
          applyCoupon={applyCoupon}
        />
      </div>
    </>
  );
};

export default Home;
